import { ComponentStyleConfig } from "@chakra-ui/react";

const NavigationSection: ComponentStyleConfig = {
	parts: ["wrapper", "container", "link", "links"],
	baseStyle: ({ isActive }) => ({
		wrapper: {
			fontSize: { base: "md", xl: "lg" },
			h: "6.75rem",
			color: "brand.blue",
			bg: "white",
			position: "sticky",
			top: { base: "5.5rem", md: "7rem" },
			zIndex: 2,
		},
		container: {
			maxW: "container.xl",
			display: "flex",
			alignItems: "center",
			m: "auto",
			h: "full",
			px: { base: 4, xl: 0 },
			overflowX: "auto",

			"> *": {
				py: 2.5,
			},
		},
		link: {
			borderRadius: 0,
			borderBottom: "2px solid",
			borderColor: isActive ? "brand.highlight" : "transparent",
			py: 0,
			px: 1.5,
			fontWeight: 500,

			_hover: {
				borderColor: "brand.highlight",
			},
		},
		links: {
			display: "flex",
			alignItems: "center",
			w: "full",
			whiteSpace: "nowrap",
			gap: 5,
		},
	}),
};

export default NavigationSection;
